import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import {
  HOME_URL,
  JOBS_URL,
  CRITERIA_URL,
  CONTACT_URL,
  FAQ_APP_URL,
  FAQ_EMP_URL,
} from '../../../constants/navRoutes';

import {
  JOBSBOARD_TITLE,
  JOBS_TITLE,
  CRITERIA_TITLE,
  CONTACT_TITLE,
  APPLICANTS_TITLE,
  EMPLOYERS_TITLE,
} from '../../../constants/titles';

import Drawer from './Drawer';

import { colours, spacing, fontSize, breakpoints } from '../../../theme';

import { ReactComponent as LogoYellow } from '../../../assets/logo-yellow.svg';
import { ReactComponent as Burger } from '../../../assets/burger-icon.svg';

const Wrapper = styled.section`
  top: 0;
  display: flex;
  background-color: ${colours.black};
  color: ${colours.white};
  padding: ${spacing.tiny};
  justify-content: space-between;
`;

const NavLeft = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NavRight = styled.section`
  display: flex;
  flex-direction: column;
  margin-right: ${spacing.tiny};

  @media (max-width: ${breakpoints.desktop}) {
    display: none;
    visibility: hidden;
  }
`;

const NavText = styled.section`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .active {
    color: ${colours.yellow};
  }
`;

const Title = styled.h1`
  font-size: ${fontSize.big};
  font-weight: 500;
  margin: 0;
`;

const Link = styled(NavLink)`
    font-size: ${fontSize.small};
    margin: 0 ${spacing.tiny};
    color: ${colours.white}
    text-decoration: none;

    :hover {
      color: ${colours.yellow}
    }
`;

const LinkImage = styled(NavLink)`
  margin-left: ${spacing.small};
`;

const MobRight = styled.section`
  display: flex;
  margin-right: ${spacing.small};
  justify-content: flex-end;
  align-items: center;

  @media (min-width: ${breakpoints.mobile}) {
    display: none;
    visibility: hidden;
  }
`;

const MobTitle = styled.section`
  font-size: ${fontSize.mobile};
  font-weight: 500;
  margin: 0 ${spacing.tiny} 0 0;
`;

const BurgerIcon = styled(Burger)`
  cursor: pointer;
`;

const Header = ({ title, setTitle }) => {
  const [burgerActive, setBurgerActive] = React.useState('100vw');

  const updateTitle = newTitle => {
    setTitle(newTitle);
    setBurgerActive('100vw');
  };

  const updateBurgerState = () => {
    setBurgerActive('0vw');
  };

  return (
    <div>
      <Wrapper>
        <NavLeft>
          <LinkImage to={HOME_URL} onClick={() => updateTitle(JOBSBOARD_TITLE)}>
            <LogoYellow />
          </LinkImage>
        </NavLeft>
        <NavRight>
          <NavText>
            <Link
              exact
              to={HOME_URL}
              title="Home"
              onClick={() => updateTitle(JOBSBOARD_TITLE)}
            >
              Home
            </Link>
            <Link
              to={JOBS_URL}
              title="Jobs"
              onClick={() => updateTitle(JOBS_TITLE)}
            >
              Jobs
            </Link>
            <Link
              to={CRITERIA_URL}
              title="Criteria"
              onClick={() => updateTitle(CRITERIA_TITLE)}
            >
              Criteria
            </Link>
            <Link
              to={CONTACT_URL}
              title="Get in touch"
              onClick={() => updateTitle(CONTACT_TITLE)}
            >
              Get in touch
            </Link>
            <Link
              to={FAQ_APP_URL}
              title="Applicants"
              onClick={() => updateTitle(APPLICANTS_TITLE)}
            >
              Applicants
            </Link>
            <Link
              to={FAQ_EMP_URL}
              title="Employers"
              onClick={() => updateTitle(EMPLOYERS_TITLE)}
            >
              Employers
            </Link>
          </NavText>
          <NavText>
            <Title>{title}</Title>
          </NavText>
        </NavRight>
        <MobRight>
          <MobTitle>{title}</MobTitle>
          <BurgerIcon onClick={() => updateBurgerState()} />
        </MobRight>
      </Wrapper>
      <Drawer
        updateTitle={updateTitle}
        burgerActive={burgerActive}
        setBurgerActive={setBurgerActive}
      />
    </div>
  );
};

export default Header;
